import {
  setClearAllOrderData,
  setClearOrder,
} from "../redux/reducers/createOrderSlice";
import { clearJobs } from "../redux/reducers/jobsSlice";

export const clearDatahandling = (dispatch) => {
  dispatch(setClearOrder());
  dispatch(setClearAllOrderData());
  dispatch(clearJobs());
  let storedData = localStorage.getItem("persist:ohc");
  let data = JSON.parse(storedData);
  if (data && data?.createOrderSlice) {
    // Delete the field
    delete data?.createOrderSlice;

    // Save the updated data back to local storage
    localStorage.setItem("persist:ohc", JSON.stringify(data));
  }
};
